import { Button } from "components/ui/button";
import React from "react";
import { Drawer } from "vaul";
import ModalReserve from "./ModalReserve";

interface Schedule {
    className?: string;
    design?: string;
    getEvents?: () => Promise<void>;
    margin?: boolean;
}

export const Schedule = ({
    className = "w-full",
    design = "white",
}: Schedule) => {
    return (
        <div className="font-poppins-regular">
            {" "}
            <Drawer.Root shouldScaleBackground>
                <Drawer.Trigger asChild>
                    <div className={`flex justify-center  ${className}`}>
                        <Button
                            className={`w-full px-8 ${
                                design === "white"
                                    ? "bg-white hover:bg-white/90 text-[#1E90FF]"
                                    : "bg-[#1E90FF] text-white hover:bg-blue-consulta-700"
                            } `}
                            type="button">
                            AGENDAR VISITA
                        </Button>
                    </div>
                </Drawer.Trigger>
                <Drawer.Portal>
                    <Drawer.Overlay
                        style={{
                            backgroundColor: "#029BFC",
                        }}
                        className="fixed inset-0"
                    />
                    <Drawer.Content
                        style={{
                            backgroundColor: "#029BFC",
                        }}
                        className={` flex flex-col rounded-t-[10px] h-[99%] mt-24 fixed bottom-0 left-0 right-0 z-50 `}>
                        <div
                            style={{
                                backgroundColor: "#029BFC",
                            }}
                            className="p-4  rounded-t-[10px] flex-1">
                            <div className="mx-auto w-12 h-1.5 flex-shrink-0 rounded-full bg-[#f2f6fb] mb-8 " />

                            <ModalReserve drawer={Drawer} />
                        </div>
                    </Drawer.Content>
                </Drawer.Portal>
            </Drawer.Root>
        </div>
    );
};
